import { NotificationEvent, Notification, OperatorType } from '../types';

const defaultEvents: NotificationEvent[] = [
    { id: 'e1', name: 'record_created', displayName: 'Record Created', recordTypeId: '' },
    { id: 'e2', name: 'record_updated', displayName: 'Record Updated', recordTypeId: '' },
    { id: 'e3', name: 'assigned_to_me', displayName: 'Assigned to Me', recordTypeId: '' },
    { id: 'e4', name: 'comment_added', displayName: 'Comment Added', recordTypeId: '' },
    { id: 'e5', name: 'status_changed', displayName: 'Status Changed', recordTypeId: '' }
];

export const mockEvents: Record<string, NotificationEvent[]> = new Proxy(
    {},
    {
        get: (target, prop: string) =>
            defaultEvents.map((event) => ({
                ...event,
                recordTypeId: prop
            }))
    }
);

export const mockOperatorsByType: Record<string, OperatorType[]> = {
    // Text types
    string: ['equals', 'not_equals', 'contains', 'does_not_contain', 'starts_with', 'ends_with', 'is_empty', 'is_not_empty'],
    text: ['equals', 'not_equals', 'contains', 'does_not_contain', 'starts_with', 'ends_with', 'is_empty', 'is_not_empty'],
    textarea: ['equals', 'not_equals', 'contains', 'does_not_contain', 'starts_with', 'ends_with', 'is_empty', 'is_not_empty'],

    // Numeric types
    number: [
        'equals',
        'not_equals',
        'less_than',
        'greater_than',
        'less_than_or_equal',
        'greater_than_or_equal',
        'is_empty',
        'is_not_empty'
    ],
    integer: [
        'equals',
        'not_equals',
        'less_than',
        'greater_than',
        'less_than_or_equal',
        'greater_than_or_equal',
        'is_empty',
        'is_not_empty'
    ],
    float: ['equals', 'not_equals', 'less_than', 'greater_than', 'less_than_or_equal', 'greater_than_or_equal', 'is_empty', 'is_not_empty'],
    decimal: [
        'equals',
        'not_equals',
        'less_than',
        'greater_than',
        'less_than_or_equal',
        'greater_than_or_equal',
        'is_empty',
        'is_not_empty'
    ],
    currency: [
        'equals',
        'not_equals',
        'less_than',
        'greater_than',
        'less_than_or_equal',
        'greater_than_or_equal',
        'is_empty',
        'is_not_empty'
    ],

    // Date types
    date: ['equals', 'not_equals', 'less_than', 'greater_than', 'less_than_or_equal', 'greater_than_or_equal', 'is_empty', 'is_not_empty'],
    datetime: [
        'equals',
        'not_equals',
        'less_than',
        'greater_than',
        'less_than_or_equal',
        'greater_than_or_equal',
        'is_empty',
        'is_not_empty'
    ],

    // Boolean types
    boolean: ['is_true', 'is_false'],
    checkbox: ['is_true', 'is_false'],

    // List types
    dropdown: ['equals', 'not_equals', 'is_empty', 'is_not_empty'],
    'single-select': ['equals', 'not_equals', 'is_empty', 'is_not_empty'],
    multiselect: ['contains', 'does_not_contain', 'is_empty', 'is_not_empty'],
    'multiselect-checkbox': ['contains', 'does_not_contain', 'is_empty', 'is_not_empty'],

    // Special types
    phone: ['equals', 'not_equals', 'contains', 'starts_with', 'is_empty', 'is_not_empty'],
    email: ['equals', 'not_equals', 'contains', 'does_not_contain', 'starts_with', 'ends_with', 'is_empty', 'is_not_empty'],
    url: ['equals', 'not_equals', 'contains', 'starts_with', 'is_empty', 'is_not_empty'],

    // Object type (complex fields with nested properties)
    object: ['contains', 'does_not_contain', 'is_empty', 'is_not_empty']
};

export const operatorDisplayNames: Record<OperatorType, string> = {
    equals: 'is equal to',
    not_equals: 'is not equal to',
    contains: 'Contains',
    starts_with: 'Starts with',
    ends_with: 'Ends with',
    greater_than: 'is greater than',
    less_than: 'is lower than',
    greater_than_or_equal: 'is greater or equal to',
    less_than_or_equal: 'is lower or equal to',
    between: 'Is within range',
    before: 'Before',
    after: 'After',
    is_empty: 'is empty',
    is_not_empty: 'is not empty',
    is: 'is',
    is_not: 'is not',
    is_any_of: 'is any of',
    does_not_contain: 'Does not contain',
    has_length_of: 'Has length of',
    is_outside_range: 'Is outside range',
    is_true: 'Is true',
    is_false: 'Is false'
};

export const priorityConfig = {
    urgent: { label: 'Urgent', color: '#FF4444', badgeColor: '#FF4444' },
    important: { label: 'Important', color: '#FB9000', badgeColor: '#FB9000' },
    regular: { label: 'Regular', color: '#858585', badgeColor: '#858585' }
};

export const frequencyDisplayNames = {
    real_time: 'Real Time',
    '10m': '10m',
    '30m': '30m',
    '60m': '60m',
    daily: 'Daily',
    weekly: 'Weekly'
};

export const mockNotifications: Notification[] = [];
